export const seoKeywords = {
  name: 'keywords',
  content:
    'IT team for startup, software developers for startup, software developers to hire, hire software team for startup, product development team, MVP development, prototype development, product demo development, discovery workshop',
};

export const startupPageSeo = {
  title: 'Software development for startups | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        "Rumble Fish's expert consultants will become your experienced partners and help you set your business for success. We offer end-to-end solutions that include idea validation, discovery workshops, technology consultancy & software development, UX services, and anything in between you might need to make your startup a successful one.",
    },
  ],
};
